<sew-headline level="4">
    {{ 'GEAR_OIL.HEADING' | translate }}
</sew-headline>
<p>{{ 'GEAR_OIL.DESCRIPTION' | translate }}</p>
<div class="flex-container">
    @switch (isMobile) {
        @case (false) {
            <sew-search-field class="serial-number" [error]="errorTextKey ? true : false">
                <ng-container *ngTemplateOutlet="searchContent"></ng-container>
            </sew-search-field>
        }
        @case (true) {
            <sew-input class="serial-number" [status]="errorTextKey ? 'error' : null">
                <ng-container *ngTemplateOutlet="searchContent"></ng-container>
            </sew-input>
        }
    }
    <ng-template #searchContent>
        <input
            id="serial_number"
            [placeholder]="'GEAR_OIL.SERIALNMUBER_INPUT_PLACEHOLDER' | translate"
            [(ngModel)]="serialNumber"
            (ngModelChange)="resetSearchError()"
            type="text"
            autocomplete="off"
            (keydown.enter)="searchGearOil()"
            class="search-input"
        />
        <div class="error-text">
            {{ errorTextKey ?? '' | translate }}
        </div>
    </ng-template>
    <sew-button class="search" hierarchy="primary" website icon="search">
        <button (click)="searchGearOil()" [disabled]="!serialNumber">
            {{ 'GEAR_OIL.SEARCH' | translate }}
        </button>
    </sew-button>
</div>
@if (false) {
    <div class="gearoil-overview">
        <p>{{ 'GEAROIL.OVERVIEW.LABEL' | translate }}</p>
        <sew-button hierarchy="secondary">
            <button (click)="gearOilOverview()">
                {{ 'GEAROIL.OVERVIEW.OPEN.LUBRICANT.OVERVIEW' | translate }}
            </button>
        </sew-button>
    </div>
}
